import { ChildrenUpperOrLower } from 'components/StackedChart/SectionsWrapper/Section/ChartItem/ChildrenUpperOrLowerWrapper/ChildrenUpperOrLowerWrapper'
import type { HighchartsOptionsWithSemiosAdditions } from 'components/StackedChart/types'
import { IcsChart } from '../IcsChart'

export const SoilChartItem = ({
  chart,
  chartVisible,
  childrenLower,
  childrenUpper,
  timezone,
}: {
  chart: HighchartsOptionsWithSemiosAdditions
  chartVisible: boolean
  childrenLower: React.ReactNode
  childrenUpper: React.ReactNode
  timezone: string
}) => {
  return (
    <div css={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      <ChildrenUpperOrLower visible={chartVisible}>{childrenUpper}</ChildrenUpperOrLower>
      <IcsChart chart={chart} chartVisible={chartVisible} timezone={timezone} />
      <ChildrenUpperOrLower visible={chartVisible}>{childrenLower}</ChildrenUpperOrLower>
    </div>
  )
}
